import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const LogoCarousel = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  const clientLogos = [
    { 
      name: 'Dangote', 
      logo: 'https://res.cloudinary.com/dlqceb87c/image/upload/v1753890962/Azellar/dangote-_pcdj8n.png',
      alt: 'Dangote Group Logo'
    },
    { 
      name: 'Orange', 
      logo: 'https://res.cloudinary.com/dlqceb87c/image/upload/v1753890801/Azellar/orange-logo_akbsaw.png',
      alt: 'Orange Logo' 
    },
    { 
      name: 'Vela', 
      logo: 'https://res.cloudinary.com/dlqceb87c/image/upload/v1753890801/Azellar/vela_qduybo.png',
      alt: 'Vela Logo'
    },
    { 
      name: 'Jaiz Bank', 
      logo: 'https://res.cloudinary.com/dlqceb87c/image/upload/v1753890800/Azellar/jaiz_bank_osb7lm.png',
      alt: 'Jaiz Bank Logo'
    },
  ];

  // Duplicate logos for seamless infinite scroll
  const duplicatedLogos = [...clientLogos, ...clientLogos];

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <section className="py-16 bg-white dark:bg-gray-900 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-4"
        >
          <p className="text-gray-600 dark:text-gray-300 text-lg">
            Trusted by leading companies worldwide
          </p>
        </motion.div>

        <div className="relative hidden lg:block">
          {/* Gradient overlays for fade effect */}
          <div className="absolute left-0 top-0 w-32 h-full bg-gradient-to-r from-white dark:from-gray-900 to-transparent z-10"></div>
          <div className="absolute right-0 top-0 w-32 h-full bg-gradient-to-l from-white dark:from-gray-900 to-transparent z-10"></div>
          
          {/* Logo carousel container */}
          <div className="flex overflow-hidden py-8">
            <motion.div
              className="flex items-center space-x-16"
              animate={{
                x: isLoaded ? [0, -50 + '%'] : 0,
              }}
              transition={{
                x: {
                  repeat: Infinity,
                  repeatType: "loop",
                  duration: 15,
                  ease: "linear",
                },
              }}
              style={{ width: '200%' }}
            >
              {duplicatedLogos.map((client, index) => (
                <motion.div
                  key={`${client.name}-${index}`}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6, delay: (index % clientLogos.length) * 0.1 }}
                  className="flex-shrink-0 flex items-center justify-center p-6 group"
                  style={{ minWidth: '200px' }}
                >
                  <div className="relative transform transition-all duration-300 group-hover:scale-110">
                    <img
                      src={client.logo}
                      alt={client.alt}
                      className="h-12 w-auto max-w-[140px] object-contain filter grayscale hover:grayscale-0 transition-all duration-300 opacity-70 hover:opacity-100"
                      loading="lazy"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        console.error(`Failed to load logo: ${client.name}`);
                      }}
                    />
                    
                    {/* Hover tooltip */}
                    <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none z-20">
                      {client.name}
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>

        {/* Static grid for mobile and tablet */}
        <div className="lg:hidden">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-items-center py-4">
            {clientLogos.map((client, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="flex items-center justify-center p-4 hover:scale-105 transition-transform duration-200"
              >
                <img
                  src={client.logo}
                  alt={client.alt}
                  className="h-10 w-auto max-w-[100px] object-contain filter grayscale hover:grayscale-0 opacity-70 hover:opacity-100 transition-all duration-300"
                  loading="lazy"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    console.error(`Failed to load logo: ${client.name}`);
                  }}
                />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoCarousel;
